module.exports = __webpack_public_path__ + "img/vue-01-11.1ec6205e.png";